function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";

class ConfigTheme extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "render", () => {
      if (this.props.darkMode) {
        return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
          rel: "stylesheet",
          type: "text/css",
          href: "/css/theme/DarkTheme.css"
        }), /*#__PURE__*/React.createElement("link", {
          rel: "stylesheet",
          type: "text/css",
          href: "/css/GlobalCustomized.css"
        }), /*#__PURE__*/React.createElement("link", {
          rel: "stylesheet",
          type: "text/css",
          href: "/css/darkTheme/DarkThemeCustomized.css"
        }));
      } else {
        return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("link", {
          rel: "stylesheet",
          type: "text/css",
          href: "/css/GlobalCustomized.css"
        }), /*#__PURE__*/React.createElement("link", {
          rel: "stylesheet",
          type: "text/css",
          href: "/css/lightTheme/LightThemeCustomized.css"
        }));
      }
    });
  }

}

function mapStateToProps(state) {
  return {
    darkMode: state.layout.darkMode
  };
}

export default connect(mapStateToProps, {})(ConfigTheme);